<script>
	export let data;

	import { cloneDeep } from "lodash-es";
	import { slide, fade } from "svelte/transition";
	import {
		isNewDataChanged,
		currentHash,
		origin,
		currentEntityID,
	} from "../../../../stores/variables";
	import { entityData } from "../../../../stores/data";
	import { request } from "../../../../scripts/request";
	import { addNotify } from "../../../../scripts/notification";

	if (data && $entityData) {
		if (!data.newData) data.newData = [];
		// if (!data.newData) window.location.reload();
		if (!data.newData[data.field_name]) data.newData[data.field_name] = [];
		if (!data.list) data.list = [];

		if (data.newData[data.field_name]) {
			data.newData[data.field_name].forEach((item) => {
				if (item.Parent == 0) {
					let temp = cloneDeep(item);
					data.list.push(temp);
				}
			});
			data.list.forEach((item) => {
				data.newData[data.field_name].forEach((subitem) => {
					if (item.id == subitem.Parent) {
						if (!item.list) item.list = [];
						let temp = cloneDeep(subitem);
						item.list.push(temp);
					}
				});
			});
			data.list.forEach((item) => {
				item.list.forEach((subitem) => {
					data.newData[data.field_name].forEach((subsubitem) => {
						if (subitem.id == subsubitem.Parent) {
							if (!subitem.list) subitem.list = [];
							let temp = cloneDeep(subsubitem);
							subitem.list.push(temp);
						}
					});
				});
			});

			data.list.forEach((level0) => {
				if (level0.list) {
					level0.list.forEach((level1) => {
						if (level1.Price || level1.MaxPrice || level1.MinPrice)
							level1.edit = true;
						if (level1.Price) level1.state = false;
						if (level1.MaxPrice || level1.MinPrice)
							level1.state = true;
						if (level1.list) {
							level1.list.forEach((level2) => {
								if (
									level2.Price ||
									level2.MaxPrice ||
									level2.MinPrice
								)
									level2.edit = true;
								if (level2.Price) level2.state = false;
								if (level2.MaxPrice || level2.MinPrice)
									level2.state = true;
							});
						}
					});
				}
			});

			data.newData[data.field_name] = [];
		}
	}

	function numberWithSpaces(x) {
		if (!x) return "";
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	}

	function editService(id, value, place, ServiceMinPrice) {
		let exist = false;
		data.newData[data.field_name].forEach((raw) => {
			if (raw.id == id) exist = true;
		});
		if (!exist) {
			let temp = {
				id: id,
				Price: "",
				MinPrice: "",
				MaxPrice: "",
				ServiceMinPrice: "",
			};
			if (place == 0) {
				temp.Price = value;
				temp.MinPrice = "";
				temp.MaxPrice = "";
			} else if (place == 1) {
				temp.MinPrice = value;
				temp.Price = "";
			} else if (place == 2) {
				temp.MaxPrice = value;
				temp.Price = "";
			}
			data.newData[data.field_name].push(temp);
		} else {
			data.newData[data.field_name].forEach((raw) => {
				if (raw.id == id) {
					if (place == 0) {
						raw.Price = value;
						raw.MinPrice = "";
						raw.MaxPrice = "";
					} else if (place == 1) {
						raw.MinPrice = value;
						raw.Price = "";
					} else if (place == 2) {
						raw.MaxPrice = value;
						raw.Price = "";
					}
					ServiceMinPrice && (raw.ServiceMinPrice = ServiceMinPrice);
				}
			});
		}
	}

	function importHanndler() {
		let url = origin + "api/v1/excel?id=" + $currentEntityID;
		window.location.assign(url);
	}
	let form2;
	function exportHanndler() {
		let d = {
			id: +$currentEntityID,
		};
		request.fetchData("excel", "send_excel", d, {}, form2).then(() => {
			addNotify("Изменения сохранены");
		});
	}
</script>

{#if data}
	<div class="excel">
		{#if data.name}
			<h3>{data.name}</h3>
		{/if}
		<span
			class="excel__icon"
			title="скачать .xls файл"
			on:click={() => importHanndler()}
			><i class="fas fa-file-excel" /></span
		>
		<form bind:this={form2}>
			<label class="excel__icon" title="загрузить .xls файл на сервер"
				><i class="fas fa-file-import" />
				<input
					type="file"
					accept=".xls"
					name="excel"
					on:input={() => exportHanndler()}
				/>
			</label>
		</form>
	</div>

	{#if data.list}
		<div class="pricelist">
			{#each data.list as level0}
				<div class="level0">
					<div
						class="level0__header"
						on:click={() => (level0.active = !level0.active)}
					>
						<span class="level0__title">{level0.name}</span>
						<i
							class="fas fa-chevron-down arrow"
							class:active={level0.active}
						/>
					</div>
					{#if level0.list}
						{#if level0.active}
							<div class="level0__content">
								<!-- <div class="level0__content" transition:slide> -->
								{#each level0.list as level1}
									<div class="level0__content-item">
										<div class="level1">
											<div class="level1__wrap">
												<span class="level1__name"
													>{level1.name}</span
												>
												{#if level1.ServiceMinPrice > 0}
													<span class="level1__info"
														>цена не может быть ниже {level1.ServiceMinPrice}
														₽</span
													>
												{/if}
											</div>
											<i
												class="far fa-exchange-alt change"
												on:click={() => {
													if (level1.state) {
														$isNewDataChanged = true;
														level1.state = false;
														level1.MinPrice =
															level1.MaxPrice =
																"";
														editService(
															level1.id,
															level1.MinPrice,
															1,
															level1.ServiceMinPrice
														);
														editService(
															level1.id,
															level1.MaxPrice,
															1,
															level1.ServiceMinPrice
														);
													} else {
														$isNewDataChanged = true;
														level1.state = true;
														level1.Price = "";
														editService(
															level1.id,
															level1.Price,
															0,
															level1.ServiceMinPrice
														);
													}
												}}
											/>
											<div class="level1__prices prices">
												{#if !level1.state}
													<div class="prices__price">
														<label>
															<input
																type="text"
																placeholder="цена"
																min={level1.ServiceMinPrice}
																class="prices__price-input"
																title="цена не может быть ниже {level1.ServiceMinPrice} ₽"
																on:input={(
																	e
																) => {
																	$isNewDataChanged = true;
																	e.target.value =
																		e.target.value.replace(
																			/[^\d.]/g,
																			""
																		);

																	editService(
																		level1.id,
																		e.target
																			.value,
																		0,
																		level1.ServiceMinPrice
																	);
																	e.target.classList.remove(
																		"invalid"
																	);
																}}
																bind:value={level1.Price}
															/>
															{#if level1.ServiceMinPrice}
																<span
																	>цена не
																	может быть
																	ниже {level1.ServiceMinPrice}
																	₽</span
																>
															{/if}
														</label>
													</div>
												{:else}
													<div class="prices__prices">
														<div>
															<label>
																<input
																	type="text"
																	class="prices__prices-input"
																	placeholder="цена от"
																	min={level1.ServiceMinPrice}
																	title="цена не может быть ниже {level1.ServiceMinPrice} ₽"
																	on:input={(
																		e
																	) => {
																		$isNewDataChanged = true;
																		e.target.value =
																			e.target.value.replace(
																				/[^\d.]/g,
																				""
																			);
																		editService(
																			level1.id,
																			e
																				.target
																				.value,
																			1,
																			level1.ServiceMinPrice
																		);
																		e.target.classList.remove(
																			"invalid"
																		);
																	}}
																	bind:value={level1.MinPrice}
																/>
																{#if level1.ServiceMinPrice}
																	<span
																		>цена не
																		может
																		быть
																		ниже {level1.ServiceMinPrice}
																		₽</span
																	>
																{/if}
															</label>
															<label>
																<input
																	type="text"
																	class="prices__prices-input"
																	placeholder="цена до"
																	min={level1.ServiceMinPrice}
																	title="цена не может быть ниже {level1.ServiceMinPrice} ₽"
																	on:input={(
																		e
																	) => {
																		$isNewDataChanged = true;
																		e.target.value =
																			e.target.value.replace(
																				/[^\d.]/g,
																				""
																			);
																		editService(
																			level1.id,
																			e
																				.target
																				.value,
																			2,
																			level1.ServiceMinPrice
																		);
																		e.target.classList.remove(
																			"invalid"
																		);
																	}}
																	bind:value={level1.MaxPrice}
																/>
																{#if level1.ServiceMinPrice}
																	<span
																		>цена не
																		может
																		быть
																		ниже {level1.ServiceMinPrice}
																		₽</span
																	>
																{/if}
															</label>
														</div>
													</div>
												{/if}
											</div>
										</div>
										{#if level1.list}
											{#each level1.list as level2}
												<div class="level2">
													<div class="level2__wrap">
														<span
															class="level2__name"
															>{level2.name}</span
														>
														{#if level2.ServiceMinPrice > 0}
															<span
																class="level2__info"
																>цена не может
																быть ниже {level2.ServiceMinPrice}
																₽</span
															>
														{/if}
													</div>
													<i
														class="far fa-exchange-alt change"
														on:click={() => {
															if (level2.state) {
																$isNewDataChanged = true;
																level2.state = false;
																level2.MinPrice =
																	level2.MaxPrice =
																		"";
																editService(
																	level2.id,
																	level2.MinPrice,
																	1,
																	level2.ServiceMinPrice
																);
																editService(
																	level2.id,
																	level2.MaxPrice,
																	1,
																	level2.ServiceMinPrice
																);
															} else {
																$isNewDataChanged = true;
																level2.state = true;
																level2.Price =
																	"";
																editService(
																	level2.id,
																	level2.Price,
																	1,
																	level2.ServiceMinPrice
																);
															}
														}}
													/>
													<div
														class="level2__prices prices"
													>
														{#if !level2.state}
															<div
																class="prices__price"
															>
																<label>
																	<input
																		type="text"
																		class="prices__price-input"
																		placeholder="цена"
																		min={level2.ServiceMinPrice}
																		title="цена не может быть ниже {level2.ServiceMinPrice} ₽"
																		on:input={(
																			e
																		) => {
																			$isNewDataChanged = true;
																			e.target.value =
																				e.target.value.replace(
																					/[^\d.]/g,
																					""
																				);
																			editService(
																				level2.id,
																				e
																					.target
																					.value,
																				0,
																				level2.ServiceMinPrice
																			);
																			e.target.classList.remove(
																				"invalid"
																			);
																		}}
																		bind:value={level2.Price}
																	/>
																	{#if level2.ServiceMinPrice}
																		<span
																			>цена
																			не
																			может
																			быть
																			ниже {level2.ServiceMinPrice}
																			₽</span
																		>
																	{/if}
																</label>
															</div>
														{:else}
															<div
																class="prices__prices"
															>
																<div>
																	<label>
																		<input
																			type="text"
																			class="prices__prices-input"
																			placeholder="цена от"
																			min={level2.ServiceMinPrice}
																			title="цена не может быть ниже {level2.ServiceMinPrice} ₽"
																			on:input={(
																				e
																			) => {
																				$isNewDataChanged = true;
																				e.target.value =
																					e.target.value.replace(
																						/[^\d.]/g,
																						""
																					);
																				editService(
																					level2.id,
																					e
																						.target
																						.value,
																					1,
																					level2.ServiceMinPrice
																				);
																				e.target.classList.remove(
																					"invalid"
																				);
																			}}
																			bind:value={level2.MinPrice}
																		/>
																		{#if level2.ServiceMinPrice}
																			<span
																				>цена
																				не
																				может
																				быть
																				ниже
																				{level2.ServiceMinPrice}
																				₽</span
																			>
																		{/if}
																	</label>
																	<label>
																		<input
																			type="text"
																			class="prices__prices-input"
																			placeholder="цена до"
																			min={level2.ServiceMinPrice}
																			title="цена не может быть ниже {level2.ServiceMinPrice} ₽"
																			on:input={(
																				e
																			) => {
																				$isNewDataChanged = true;
																				e.target.value =
																					e.target.value.replace(
																						/[^\d.]/g,
																						""
																					);
																				editService(
																					level2.id,
																					e
																						.target
																						.value,
																					2,
																					level2.ServiceMinPrice
																				);

																				e.target.classList.remove(
																					"invalid"
																				);
																			}}
																			bind:value={level2.MaxPrice}
																		/>
																		{#if level2.ServiceMinPrice}
																			<span
																				>цена
																				не
																				может
																				быть
																				ниже
																				{level2.ServiceMinPrice}
																				₽</span
																			>
																		{/if}
																	</label>
																</div>
															</div>
														{/if}
													</div>
												</div>
											{/each}
										{/if}
									</div>
								{/each}
							</div>
						{/if}
					{/if}
				</div>
			{/each}
		</div>
	{/if}
{/if}

<div class="blank">
	<input type="text" class="invalid" />
	<span />
</div>

<style lang="scss">
	.blank {
		display: none;
		position: absolute;
		z-index: -100;
		overflow: hidden;
		opacity: 0;
		pointer-events: none;
		> * {
			display: none;
		}
	}
	.popup {
		position: fixed;
		z-index: 10001;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: auto;

		&__bg {
			cursor: pointer;
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: #00000066;
			z-index: -1;
		}

		&__cross {
			position: absolute;
			cursor: pointer;
			top: 18px;
			right: 18px;
			font-size: 20px;
		}

		&__body {
			background: var(--bg-main-1);
			position: relative;
			border-radius: 16px;
			margin: 0 30px;
			overflow: hidden;
			display: flex;
			max-height: 80vh;
			max-width: 80vw;
			padding: 30px;
			flex-direction: column;
			> b {
				font-size: 20px;
				margin-right: 20px;
			}
			> span {
				margin-top: 16px;
				font-size: 16px;
				&:first-child {
					margin-bottom: 12px;
				}
				> b {
					color: var(--color-1);
				}
			}
		}
	}
	.prices {
		margin-left: 6px;
	}
	.excel {
		display: flex;
		&__icon {
			display: flex;
			cursor: pointer;
			font-size: 30px;
			> i {
				font-weight: 100;
				margin: 0 0 0 15px;
				color: var(--color-1);
			}
			> input {
				display: none;
			}
		}
	}
	label {
		position: relative;
		> span {
			position: absolute;
			display: none;
		}
	}
	input {
		padding: 8px;
		width: 100px;
		border-radius: 8px;
		border: solid 1px var(--border-gray-1);
		outline-color: #a5a6af;
	}

	input.invalid {
		+ span {
			display: flex;
			right: 0;
			top: 100%;
			pointer-events: none;
			margin-top: 10px;
			padding: 16px 24px;
			border-radius: 20px;
			box-shadow: 4px 4px 8px 0px #223c5033;
			width: 200px;
			z-index: 1;
			text-align: center;
			color: var(--text-black-1);
			background: var(--bg-main-1);
		}
	}
	i {
		margin: 0 5px;
		font-weight: 500;
	}

	.pricelist {
		display: flex;
		flex-direction: column;
		z-index: 1;
		position: relative;
	}
	.level0 {
		display: flex;
		flex-direction: column;

		&__header {
			display: flex;
			position: relative;
			cursor: pointer;
			padding: 10px 0;

			&::before {
				content: "";
				height: 1px;
				background: #00000033;
				margin: 0 -40px;
				top: 50%;
				position: absolute;
				width: calc(100% + 80px);
				z-index: -1;
			}

			> i {
				display: flex;
				margin-left: auto;
				transition: all 0.3s ease;
				height: 0;
				width: 0;
				padding: 12px;
				color: var(--color-1);
				font-size: 14px;
				border: solid 1px #00000033;
				align-items: center;
				justify-content: center;
				border-radius: 50%;
				background: var(--bg-main-1);

				&.active {
					transform: rotate(180deg);
				}
			}
		}

		&__title {
			font-size: 16px;
			font-weight: 700;
			background: var(--bg-main-1);
			align-self: center;
		}
		&__content {
			display: flex;
			flex-direction: column;

			&-item {
				display: flex;
				flex-direction: column;
			}
		}
	}
	.level1 {
		padding: 20px 0;
		display: flex;
		align-items: center;

		> i {
			cursor: pointer;
			color: var(--color-1);
		}

		&__name {
			margin-right: auto;
			background: var(--bg-main-1);
		}

		&__wrap {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			position: relative;
			&::before {
				content: "";
				height: 1px;
				top: 50%;
				position: absolute;
				width: 100%;
				z-index: -1;
				border-bottom: 1px #00000033 dashed;
			}
		}

		&__info {
			display: flex;
			margin-top: 10px;
			font-size: 12px;
			opacity: 0.4;
		}
	}
	.level2 {
		display: flex;
		align-items: center;
		padding: 20px 0;
		margin-left: 16px;
		> i {
			cursor: pointer;
			color: var(--color-1);
		}

		&__wrap {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			position: relative;
			&::before {
				content: "";
				height: 1px;
				top: 50%;
				position: absolute;
				width: 100%;
				z-index: -1;
				border-bottom: 1px #00000033 dashed;
			}
		}

		&__info {
			display: flex;
			margin-top: 10px;
			font-size: 12px;
			opacity: 0.4;
		}

		&__name {
			font-size: 14px;
			margin-right: auto;
			background: var(--bg-main-1);
		}
	}
</style>
